import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { PatientPayersActions } from 'src/redux/actions/constant';
import patientService from 'src/services/apiServices/patientService';

const {
  GET_PAYER_HISTORY_REQUEST,
  GET_PAYER_HISTORY_SUCCESS,
  GET_PAYER_HISTORY_FAILURE,
  GET_PAYER_HISTORY_LOADING,
} = PatientPayersActions;

function* getPayerHistory(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PAYER_HISTORY_LOADING });
    const response = yield call(patientService.getPayerHistory, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PAYER_HISTORY_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PAYER_HISTORY_FAILURE, payload: error });
  }
}

function* getPayerHistorySaga() {
  yield takeEvery(GET_PAYER_HISTORY_REQUEST, getPayerHistory);
}

export default getPayerHistorySaga;
